import { useSearchParams } from 'react-router-dom'

export const useForceLanguage = (): string | undefined => {
  const [searchParams] = useSearchParams()

  return searchParams.get('forceLanguage') || undefined
}
